import Navbar from "@/components/site/Navbar";
import Hero from "@/components/site/Hero";
import Expertise from "@/components/site/Expertise";
import Gallery from "@/components/site/Gallery";
import WhyUs from "@/components/site/WhyUs";
import Process from "@/components/site/Process";
import Testimonials from "@/components/site/Testimonials";
import ContactCTA from "@/components/site/ContactCTA";
import Footer from "@/components/site/Footer";
import PageHead from "@/components/site/PageHead";
import usePageContent from "@/hooks/usePageContent";

export default function Landing() {
    const t = usePageContent("home");
    return (
        <main data-testid="landing-page" className="min-h-screen bg-[#FDFBF7] text-[#1E3A5F]">
            <PageHead seo={t.seo} path="/" />
            <Navbar />
            <Hero />
            <Expertise />
            <Gallery />
            <WhyUs />
            <Process />
            <Testimonials />
            <ContactCTA />
            <Footer />
        </main>
    );
}
